import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext'; 
import planeIcon from '../img/icone-d-avion.png';
import timeIcon from '../img/time-icon.png';
import tagIcon from '../img/tag-icon.png';

function OfferCard({ offer }) {
  const { language } = useContext(LanguageContext); 

  
  const content = {
    fr: {
      company: 'Compagnie',
      duration: 'Durée',
      price: 'À partir de',
      soon: 'PROCHAINEMENT',
      learnMore: 'EN SAVOIR PLUS',
    },
    ar: {
      company: 'الشركة',
      duration: 'المدة',
      price: 'ابتداءً من',
      soon: 'قريباً',
      learnMore: 'معرفة المزيد',
    },
  };

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 relative">
      <figure className="relative">
        <img src={offer.thumbImage} alt={offer.title} className="w-full h-48 object-cover" />
        
        
        {offer.tag && (
          <div className="absolute top-4 left-0 bg-green-600 text-white text-sm font-bold px-4 py-1 rounded-tr-lg rounded-br-lg shadow-md">
            {content[language].soon}
          </div>
        )}
      </figure>

      <div className="p-6">
        <small className="text-gray-500">{offer.dates}</small>
        
       
        <h3 className="text-xl font-bold text-gray-800 mt-2 hover:text-green-600 transition-colors duration-300">
          {offer.title}
        </h3>

        <ul className="mt-4 space-y-3">
          <li className="flex items-center">
            <img src={planeIcon} alt="Compagnie" className="w-6 h-6 mr-2" />
            <div>
              <small className="text-gray-500">{content[language].company}</small>
              <span className="block text-gray-800">{offer.airline}</span>
            </div>
          </li>
          <li className="flex items-center">
            <img src={timeIcon} alt="Durée" className="w-6 h-6 mr-2" />
            <div>
              <small className="text-gray-500">{content[language].duration}</small>
              <span className="block text-gray-800">{offer.duration}</span>
            </div>
          </li>
          <li className="flex items-center">
            <img src={tagIcon} alt="Prix" className="w-6 h-6 mr-2" />
            <div>
              <small className="text-gray-500">{content[language].price}</small>
              <span className="block text-gray-800">{offer.price}</span>
            </div>
          </li>
        </ul>

        
        <Link
          to={`/reservation/${offer.title.replace(/\s+/g, '-').toLowerCase()}`}
          className={`mt-6 inline-block w-full text-center ${
            offer.tag ? 'bg-gray-300 cursor-not-allowed pointer-events-none' : 'bg-green-500 hover:bg-green-600'
          } text-white py-2 px-4 rounded-lg transition-colors duration-300`}
        >
          {offer.tag ? content[language].soon : content[language].learnMore}
        </Link>
      </div>
    </div>
  );
}

export default OfferCard;